import { ReactElement } from 'react';
import { Currency } from 'utils/Currency';
import { getCurrencySymbolFromEnum } from 'lib/region/countryUtils';

// Create JSX elements from the centralized string mapping
// Using lazy initialization to avoid temporal dead zone issues with getCurrencySymbolFromEnum
let _currencySymbolCache: { [key in Currency]: ReactElement } | null = null;

const initializeCurrencySymbol = (): { [key in Currency]: ReactElement } => {
  if (!_currencySymbolCache) {
    _currencySymbolCache = {
      [Currency.inr]: <>{getCurrencySymbolFromEnum(Currency.inr)}</>,
      [Currency.eur]: <>{getCurrencySymbolFromEnum(Currency.eur)}</>,
      [Currency.gbp]: <>{getCurrencySymbolFromEnum(Currency.gbp)}</>,
      [Currency.aed]: <>{getCurrencySymbolFromEnum(Currency.aed)}</>,
      [Currency.usd]: <>{getCurrencySymbolFromEnum(Currency.usd)}</>,
      [Currency.ch]: <>{getCurrencySymbolFromEnum(Currency.ch)}</>,
      [Currency.hk_usd]: <>{getCurrencySymbolFromEnum(Currency.hk_usd)}</>,
      [Currency.aud]: <>{getCurrencySymbolFromEnum(Currency.aud)}</>,
      [Currency.bgn]: <>{getCurrencySymbolFromEnum(Currency.bgn)}</>,
      [Currency.brl]: <>{getCurrencySymbolFromEnum(Currency.brl)}</>,
      [Currency.cad]: <>{getCurrencySymbolFromEnum(Currency.cad)}</>,
      [Currency.clp]: <>{getCurrencySymbolFromEnum(Currency.clp)}</>,
      [Currency.cny]: <>{getCurrencySymbolFromEnum(Currency.cny)}</>,
      [Currency.cop]: <>{getCurrencySymbolFromEnum(Currency.cop)}</>,
      [Currency.czk]: <>{getCurrencySymbolFromEnum(Currency.czk)}</>,
      [Currency.dkk]: <>{getCurrencySymbolFromEnum(Currency.dkk)}</>,
      [Currency.egp]: <>{getCurrencySymbolFromEnum(Currency.egp)}</>,
      [Currency.hkd]: <>{getCurrencySymbolFromEnum(Currency.hkd)}</>,
      [Currency.huf]: <>{getCurrencySymbolFromEnum(Currency.huf)}</>,
      [Currency.idr]: <>{getCurrencySymbolFromEnum(Currency.idr)}</>,
      [Currency.ils]: <>{getCurrencySymbolFromEnum(Currency.ils)}</>,
      [Currency.jpy]: <>{getCurrencySymbolFromEnum(Currency.jpy)}</>,
      [Currency.krw]: <>{getCurrencySymbolFromEnum(Currency.krw)}</>,
      [Currency.kzt]: <>{getCurrencySymbolFromEnum(Currency.kzt)}</>,
      [Currency.mxn]: <>{getCurrencySymbolFromEnum(Currency.mxn)}</>,
      [Currency.myr]: <>{getCurrencySymbolFromEnum(Currency.myr)}</>,
      [Currency.ngn]: <>{getCurrencySymbolFromEnum(Currency.ngn)}</>,
      [Currency.nok]: <>{getCurrencySymbolFromEnum(Currency.nok)}</>,
      [Currency.nzd]: <>{getCurrencySymbolFromEnum(Currency.nzd)}</>,
      [Currency.pen]: <>{getCurrencySymbolFromEnum(Currency.pen)}</>,
      [Currency.php]: <>{getCurrencySymbolFromEnum(Currency.php)}</>,
      [Currency.pkr]: <>{getCurrencySymbolFromEnum(Currency.pkr)}</>,
      [Currency.pln]: <>{getCurrencySymbolFromEnum(Currency.pln)}</>,
      [Currency.qar]: <>{getCurrencySymbolFromEnum(Currency.qar)}</>,
      [Currency.ron]: <>{getCurrencySymbolFromEnum(Currency.ron)}</>,
      [Currency.rub]: <>{getCurrencySymbolFromEnum(Currency.rub)}</>,
      [Currency.sar]: <>{getCurrencySymbolFromEnum(Currency.sar)}</>,
      [Currency.sek]: <>{getCurrencySymbolFromEnum(Currency.sek)}</>,
      [Currency.sgd]: <>{getCurrencySymbolFromEnum(Currency.sgd)}</>,
      [Currency.thb]: <>{getCurrencySymbolFromEnum(Currency.thb)}</>,
      [Currency.try]: <>{getCurrencySymbolFromEnum(Currency.try)}</>,
      [Currency.twd]: <>{getCurrencySymbolFromEnum(Currency.twd)}</>,
      [Currency.tzs]: <>{getCurrencySymbolFromEnum(Currency.tzs)}</>,
      [Currency.vnd]: <>{getCurrencySymbolFromEnum(Currency.vnd)}</>,
      [Currency.zar]: <>{getCurrencySymbolFromEnum(Currency.zar)}</>,
    };
  }
  return _currencySymbolCache;
};

// Export a Proxy that lazily initializes on first access
export const CurrencySymbol: { [key in Currency]: ReactElement } = new Proxy(
  {} as { [key in Currency]: ReactElement },
  {
    get: (_target, prop: string | symbol) => {
      return initializeCurrencySymbol()[prop as Currency];
    },
  }
);
